import React from "react";
import PropTypes from "prop-types";
import _ from "lodash";

import "./styles/style.scss";

const Checkbox = ({ isError, size, direction, ...rest }) => {
  /**
   * Вернуть класс, применяемый для позиционирования компонента
   *
   * @param {String} value
   * @return {String}
   */
  const getDirectionClass = value => {
    const classes = {
      row: "checkbox--row",
      column: "checkbox--column",
    };

    return _.get(classes, value, Checkbox.defaultProps.direction);
  };

  /**
   * Вернуть класс, применяемый для размера компонента
   *
   * @param {String} value
   * @return {String}
   */
  const getSizeClass = value => {
    const classes = {
      lg: "checkbox--lg",
      md: "checkbox--md",
      sm: "checkbox--sm",
    };

    return _.get(classes, value, Checkbox.defaultProps.size);
  };

  const { children, ...domProps } = rest;
  const classNames = [
    "checkbox",
    isError && "checkbox--invalid",
    getSizeClass(size),
    getDirectionClass(direction),
    rest.disabled && "checkbox--disabled",
    rest.className,
  ]
    .filter(name => name)
    .join(" ");

  return (
    <label className={classNames} style={rest.style}>
      <input {...domProps} type="checkbox" />
      <span className="checkmark"></span>
      {children}
    </label>
  );
};

Checkbox.propTypes = {
  isError: PropTypes.bool,
  size: PropTypes.string,
  direction: PropTypes.string,
};

Checkbox.defaultProps = {
  isError: false,
  size: "lg",
  direction: "row",
};

export default Checkbox;
